module.exports = __webpack_public_path__ + "img/SELIA.153338dc.png";